module.exports = __webpack_public_path__ + "static/images/checked-round.XjRqKb_.svg";